import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const PAGINAS_DISPONIVEIS = [
  // Principal
  { rota: '/', label: 'Dashboard', grupo: 'Principal', icon: '📊' },
  // Atendimento
  { rota: '/pacientes', label: 'Pacientes', grupo: 'Atendimento', icon: '👥' },
  { rota: '/solicitacoes', label: 'Solicitações', grupo: 'Atendimento', icon: '📋' },
  { rota: '/atendimentos', label: 'Atendimentos', grupo: 'Atendimento', icon: '🏥' },
  { rota: '/coletas-domiciliares', label: 'Coletas Domiciliares', grupo: 'Atendimento', icon: '🏠' },
  { rota: '/agendamentos-coleta', label: 'Agendamentos de Coleta', grupo: 'Atendimento', icon: '📅' },
  // Exames e Resultados
  { rota: '/resultados', label: 'Resultados', grupo: 'Exames e Resultados', icon: '📋' },
  { rota: '/lab-apoio', label: 'Lab. de Apoio', grupo: 'Exames e Resultados', icon: '🏥' },
  { rota: '/orcamentos', label: 'Orçamentos', grupo: 'Exames e Resultados', icon: '💰' },
  { rota: '/faturamento', label: 'Faturamento', grupo: 'Exames e Resultados', icon: '💳' },
  { rota: '/tempo-exames', label: 'Tempo de Exames (TAT)', grupo: 'Exames e Resultados', icon: '⏱️' },
  // Financeiro
  { rota: '/financeiro', label: 'Financeiro', grupo: 'Financeiro', icon: '💵' },
  { rota: '/relatorio-faturamento', label: 'Relatório de Faturamento', grupo: 'Financeiro', icon: '📈' },
  { rota: '/conferencia-convenios', label: 'Conferência de Convênios', grupo: 'Financeiro', icon: '🔍' },
  { rota: '/conferencia-hospital', label: 'Conferência Hospital (PAM)', grupo: 'Financeiro', icon: '🏥' },
  { rota: '/tabela-unimed', label: 'Tabela UNIMED × pagamentos', grupo: 'Financeiro', icon: '📋' },
  { rota: '/tiss-unimed', label: 'TISS UNIMED', grupo: 'Financeiro', icon: '🏥' },
  { rota: '/ipsemg', label: 'IPSEMG (TES)', grupo: 'Financeiro', icon: '🏥' },
  { rota: '/financeiro/pix-config', label: 'Configuração PIX', grupo: 'Financeiro', icon: '🔑' },
  // Cadastros
  { rota: '/exames', label: 'Exames', grupo: 'Cadastros', icon: '🧪' },
  { rota: '/aparelhos', label: 'Aparelhos', grupo: 'Cadastros', icon: '⚙️' },
  { rota: '/setores', label: 'Setores', grupo: 'Cadastros', icon: '🏢' },
  { rota: '/locais', label: 'Locais', grupo: 'Cadastros', icon: '📍' },
  { rota: '/laboratorios', label: 'Laboratórios', grupo: 'Cadastros', icon: '🏥' },
  { rota: '/medicos', label: 'Médicos', grupo: 'Cadastros', icon: '👨‍⚕️' },
  { rota: '/laudos', label: 'Laudos', grupo: 'Cadastros', icon: '📝' },
  { rota: '/convenios', label: 'Convênios', grupo: 'Cadastros', icon: '🏦' },
  { rota: '/materiais-metodos', label: 'Materiais e Métodos', grupo: 'Cadastros', icon: '🧫' },
  { rota: '/responsaveis', label: 'Responsáveis Técnicos', grupo: 'Cadastros', icon: '👨‍🔬' },
  { rota: '/bancadas', label: 'Bancadas', grupo: 'Cadastros', icon: '🔬' },
  { rota: '/recipientes', label: 'Recipientes', grupo: 'Cadastros', icon: '🧪' },
  // WhatsApp
  { rota: '/whatsapp-conversas', label: 'Conversas', grupo: 'WhatsApp', icon: '💬' },
  { rota: '/whatsapp-envios', label: 'Envio de Resultados', grupo: 'WhatsApp', icon: '📤' },
  { rota: '/whatsapp-mensagens', label: 'Mensagens Recebidas', grupo: 'WhatsApp', icon: '📥' },
  { rota: '/whatsapp-contatos', label: 'Contatos', grupo: 'WhatsApp', icon: '📇' },
  { rota: '/whatsapp-historico', label: 'Histórico de Envios', grupo: 'WhatsApp', icon: '🕓' },
  { rota: '/whatsapp-dashboard', label: 'Dashboard WhatsApp', grupo: 'WhatsApp', icon: '📊' },
  { rota: '/whatsapp-agente', label: 'Agente de IA', grupo: 'WhatsApp', icon: '🤖' },
  { rota: '/whatsapp-diagnostico', label: 'Diagnóstico WhatsApp', grupo: 'WhatsApp', icon: '🩺' },
  { rota: '/whatsapp-config', label: 'Configurações WhatsApp', grupo: 'WhatsApp', icon: '⚙️' },
  // Gestão
  { rota: '/painel-administrativo', label: 'Painel Administrativo', grupo: 'Gestão', icon: '📊' },
  { rota: '/painel-gestor', label: 'Painel do Gestor', grupo: 'Gestão', icon: '🎯' },
  { rota: '/painel-inconsistencias', label: 'Inconsistências', grupo: 'Gestão', icon: '⚠️' },
  // Sistema
  { rota: '/tabelas', label: 'Explorador de Tabelas', grupo: 'Sistema', icon: '🗄️' },
  { rota: '/api-docs', label: 'Documentação da API', grupo: 'Sistema', icon: '📚' },
  { rota: '/perfis', label: 'Gerenciar Perfis', grupo: 'Sistema', icon: '🛡️' },
  { rota: '/usuarios', label: 'Gerenciar Usuários', grupo: 'Sistema', icon: '👤' },
  { rota: '/teste-ia', label: 'Teste de IA', grupo: 'Sistema', icon: '🧪' },
  { rota: '/teste-ia/analises', label: 'Análises de IA', grupo: 'Sistema', icon: '📉' },
  { rota: '/teste-agente', label: 'Teste do Agente', grupo: 'Sistema', icon: '🧬' },
];

const GRUPOS = [...new Set(PAGINAS_DISPONIVEIS.map(p => p.grupo))];

function GerenciarPerfis() {
  const [perfis, setPerfis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingPerfil, setEditingPerfil] = useState(null);
  const [formData, setFormData] = useState({ nome: '', descricao: '', permissoes: [] });
  const [mensagem, setMensagem] = useState({ texto: '', tipo: '' });

  useEffect(() => {
    fetchPerfis();
  }, []);

  useEffect(() => {
    if (mensagem.texto) {
      const timer = setTimeout(() => setMensagem({ texto: '', tipo: '' }), 4000);
      return () => clearTimeout(timer);
    }
  }, [mensagem]);

  const fetchPerfis = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/auth/perfis`);
      setPerfis(response.data || []);
    } catch (err) {
      console.error('Erro ao buscar perfis:', err);
      setMensagem({ texto: 'Erro ao carregar perfis.', tipo: 'erro' });
    } finally {
      setLoading(false);
    }
  };

  const handleNovoPerfil = () => {
    setEditingPerfil(null);
    setFormData({ nome: '', descricao: '', permissoes: [] });
    setModalOpen(true);
  };

  const handleEditarPerfil = (perfil) => {
    setEditingPerfil(perfil);
    setFormData({
      nome: perfil.nome || '',
      descricao: perfil.descricao || '',
      permissoes: perfil.permissoes || [],
    });
    setModalOpen(true);
  };

  const handleDeletarPerfil = async (perfil) => {
    if (!window.confirm(`Tem certeza que deseja excluir o perfil "${perfil.nome}"?`)) {
      return;
    }
    try {
      await axios.delete(`${API_URL}/auth/perfis/${perfil.id}`);
      setMensagem({ texto: `Perfil "${perfil.nome}" excluído com sucesso.`, tipo: 'sucesso' });
      fetchPerfis();
    } catch (err) {
      console.error('Erro ao deletar perfil:', err);
      const msg = err.response?.data?.error || 'Erro ao excluir perfil.';
      setMensagem({ texto: msg, tipo: 'erro' });
    }
  };

  const handleSalvar = async () => {
    if (!formData.nome.trim()) {
      setMensagem({ texto: 'O nome do perfil é obrigatório.', tipo: 'erro' });
      return;
    }

    setSaving(true);
    try {
      if (editingPerfil) {
        await axios.put(`${API_URL}/auth/perfis/${editingPerfil.id}`, formData);
        setMensagem({ texto: `Perfil "${formData.nome}" atualizado com sucesso.`, tipo: 'sucesso' });
      } else {
        await axios.post(`${API_URL}/auth/perfis`, formData);
        setMensagem({ texto: `Perfil "${formData.nome}" criado com sucesso.`, tipo: 'sucesso' });
      }
      setModalOpen(false);
      fetchPerfis();
    } catch (err) {
      console.error('Erro ao salvar perfil:', err);
      const msg = err.response?.data?.error || 'Erro ao salvar perfil.';
      setMensagem({ texto: msg, tipo: 'erro' });
    } finally {
      setSaving(false);
    }
  };

  const handleTogglePermissao = (rota) => {
    setFormData(prev => {
      const permissoes = prev.permissoes.includes(rota)
        ? prev.permissoes.filter(p => p !== rota)
        : [...prev.permissoes, rota];
      return { ...prev, permissoes };
    });
  };

  const handleToggleGrupo = (grupo) => {
    const rotasDoGrupo = PAGINAS_DISPONIVEIS.filter(p => p.grupo === grupo).map(p => p.rota);
    const todasSelecionadas = rotasDoGrupo.every(r => formData.permissoes.includes(r));

    setFormData(prev => {
      let permissoes;
      if (todasSelecionadas) {
        permissoes = prev.permissoes.filter(p => !rotasDoGrupo.includes(p));
      } else {
        const novas = rotasDoGrupo.filter(r => !prev.permissoes.includes(r));
        permissoes = [...prev.permissoes, ...novas];
      }
      return { ...prev, permissoes };
    });
  };

  const isGrupoCompleto = (grupo) => {
    const rotasDoGrupo = PAGINAS_DISPONIVEIS.filter(p => p.grupo === grupo).map(p => p.rota);
    return rotasDoGrupo.every(r => formData.permissoes.includes(r));
  };

  const isGrupoParcial = (grupo) => {
    const rotasDoGrupo = PAGINAS_DISPONIVEIS.filter(p => p.grupo === grupo).map(p => p.rota);
    const selecionadas = rotasDoGrupo.filter(r => formData.permissoes.includes(r));
    return selecionadas.length > 0 && selecionadas.length < rotasDoGrupo.length;
  };

  const handleFecharModal = () => {
    setModalOpen(false);
    setEditingPerfil(null);
    setFormData({ nome: '', descricao: '', permissoes: [] });
  };

  // --- Estilos ---
  const styles = {
    page: {
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
    },
    breadcrumb: {
      fontSize: '13px',
      color: '#888',
      marginBottom: '4px',
    },
    breadcrumbLink: {
      color: '#1976d2',
      textDecoration: 'none',
      cursor: 'pointer',
    },
    pageHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '24px',
      flexWrap: 'wrap',
      gap: '12px',
    },
    pageIcon: {
      fontSize: '1.5rem',
      lineHeight: 1,
    },
    pageTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#1a1a2e',
      margin: '0 0 2px 0',
    },
    pageSubtitle: {
      fontSize: '0.85rem',
      color: '#666',
      margin: 0,
    },
    btnPrimary: {
      backgroundColor: '#1976d2',
      color: '#fff',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'background-color 0.2s',
    },
    card: {
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      overflow: 'hidden',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '14px',
    },
    th: {
      textAlign: 'left',
      padding: '12px 16px',
      backgroundColor: '#fafafa',
      borderBottom: '2px solid #e8e8e8',
      color: '#555',
      fontWeight: '600',
      fontSize: '13px',
      textTransform: 'uppercase',
      letterSpacing: '0.3px',
    },
    td: {
      padding: '12px 16px',
      borderBottom: '1px solid #f0f0f0',
      color: '#333',
    },
    trHover: {
      transition: 'background-color 0.15s',
    },
    perfilNome: {
      fontWeight: '600',
      color: '#333',
    },
    perfilDescricao: {
      color: '#666',
      fontSize: '13px',
    },
    badge: {
      display: 'inline-block',
      backgroundColor: '#e3f2fd',
      color: '#1565c0',
      padding: '2px 10px',
      borderRadius: '12px',
      fontSize: '13px',
      fontWeight: '500',
    },
    actions: {
      display: 'flex',
      gap: '8px',
    },
    btnEditar: {
      backgroundColor: '#fff',
      color: '#1976d2',
      border: '1px solid #1976d2',
      padding: '6px 14px',
      borderRadius: '4px',
      fontSize: '13px',
      cursor: 'pointer',
      fontWeight: '500',
      transition: 'all 0.2s',
    },
    btnDeletar: {
      backgroundColor: '#fff',
      color: '#dc3545',
      border: '1px solid #dc3545',
      padding: '6px 14px',
      borderRadius: '4px',
      fontSize: '13px',
      cursor: 'pointer',
      fontWeight: '500',
      transition: 'all 0.2s',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modal: {
      backgroundColor: '#fff',
      borderRadius: '10px',
      width: '100%',
      maxWidth: 'min(700px, 95vw)',
      maxHeight: '85vh',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px 24px',
      borderBottom: '1px solid #e8e8e8',
    },
    modalTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      margin: 0,
    },
    modalClose: {
      background: 'none',
      border: 'none',
      fontSize: '22px',
      color: '#999',
      cursor: 'pointer',
      padding: '4px 8px',
      lineHeight: 1,
    },
    modalBody: {
      padding: '24px',
      overflowY: 'auto',
      flex: 1,
    },
    formGroup: {
      marginBottom: '20px',
    },
    label: {
      display: 'block',
      fontSize: '13px',
      fontWeight: '600',
      color: '#555',
      marginBottom: '6px',
      textTransform: 'uppercase',
      letterSpacing: '0.3px',
    },
    input: {
      width: '100%',
      padding: '10px 12px',
      border: '1px solid #ddd',
      borderRadius: '6px',
      fontSize: '14px',
      color: '#333',
      outline: 'none',
      transition: 'border-color 0.2s',
      boxSizing: 'border-box',
    },
    textarea: {
      width: '100%',
      padding: '10px 12px',
      border: '1px solid #ddd',
      borderRadius: '6px',
      fontSize: '14px',
      color: '#333',
      outline: 'none',
      transition: 'border-color 0.2s',
      boxSizing: 'border-box',
      resize: 'vertical',
      minHeight: '60px',
      fontFamily: 'inherit',
    },
    permissoesSection: {
      marginTop: '8px',
    },
    grupoHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '10px 12px',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px',
      marginBottom: '8px',
      cursor: 'pointer',
      userSelect: 'none',
      border: '1px solid #e8e8e8',
    },
    grupoLabel: {
      fontWeight: '600',
      fontSize: '14px',
      color: '#333',
    },
    grupoCount: {
      fontSize: '12px',
      color: '#888',
      marginLeft: 'auto',
    },
    permissaoItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '6px 12px 6px 32px',
      cursor: 'pointer',
      userSelect: 'none',
      borderRadius: '4px',
      transition: 'background-color 0.15s',
    },
    permissaoLabel: {
      fontSize: '14px',
      color: '#444',
    },
    grupoWrapper: {
      marginBottom: '16px',
    },
    modalFooter: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
      padding: '16px 24px',
      borderTop: '1px solid #e8e8e8',
      backgroundColor: '#fafafa',
    },
    btnCancelar: {
      backgroundColor: '#fff',
      color: '#666',
      border: '1px solid #ddd',
      padding: '10px 20px',
      borderRadius: '6px',
      fontSize: '14px',
      cursor: 'pointer',
      fontWeight: '500',
    },
    btnSalvar: {
      backgroundColor: '#1976d2',
      color: '#fff',
      border: 'none',
      padding: '10px 24px',
      borderRadius: '6px',
      fontSize: '14px',
      cursor: 'pointer',
      fontWeight: '500',
      opacity: 1,
    },
    btnSalvarDisabled: {
      backgroundColor: '#90caf9',
      color: '#fff',
      border: 'none',
      padding: '10px 24px',
      borderRadius: '6px',
      fontSize: '14px',
      cursor: 'not-allowed',
      fontWeight: '500',
      opacity: 0.7,
    },
    mensagem: {
      padding: '12px 16px',
      borderRadius: '6px',
      marginBottom: '16px',
      fontSize: '14px',
      fontWeight: '500',
    },
    mensagemSucesso: {
      backgroundColor: '#e8f5e9',
      color: '#2e7d32',
      border: '1px solid #c8e6c9',
    },
    mensagemErro: {
      backgroundColor: '#ffebee',
      color: '#c62828',
      border: '1px solid #ffcdd2',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 0',
      color: '#888',
      fontSize: '15px',
    },
    emptyState: {
      textAlign: 'center',
      padding: '48px 24px',
      color: '#888',
    },
    emptyIcon: {
      fontSize: '40px',
      marginBottom: '12px',
    },
    emptyText: {
      fontSize: '15px',
      color: '#666',
      marginBottom: '4px',
    },
    emptySub: {
      fontSize: '13px',
      color: '#999',
    },
    checkbox: {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
      accentColor: '#1976d2',
    },
  };

  if (loading) {
    return (
      <div className="data-page" style={styles.page}>
        <div style={styles.loadingContainer}>
          Carregando perfis...
        </div>
      </div>
    );
  }

  return (
    <div className="data-page" style={styles.page}>
      {/* Breadcrumb */}
      <div style={styles.breadcrumb}>
        <span style={styles.breadcrumbLink}>Sistema</span>
        <span> / </span>
        <span>Gerenciar Perfis</span>
      </div>

      {/* Header */}
      <div className="responsive-flex" style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🛡️</span>
          <div>
            <h1 style={styles.pageTitle}>Gerenciar Perfis</h1>
            <p style={styles.pageSubtitle}>
              {perfis.length} {perfis.length === 1 ? 'perfil cadastrado' : 'perfis cadastrados'}
            </p>
          </div>
        </div>
        <button
          style={styles.btnPrimary}
          onClick={handleNovoPerfil}
          onMouseEnter={e => { e.target.style.backgroundColor = '#1565c0'; }}
          onMouseLeave={e => { e.target.style.backgroundColor = '#1976d2'; }}
        >
          + Novo Perfil
        </button>
      </div>

      {/* Mensagem de feedback */}
      {mensagem.texto && (
        <div style={{
          ...styles.mensagem,
          ...(mensagem.tipo === 'sucesso' ? styles.mensagemSucesso : styles.mensagemErro),
        }}>
          {mensagem.texto}
        </div>
      )}

      {/* Tabela de perfis */}
      <div style={styles.card}>
        {perfis.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyIcon}>🛡️</div>
            <p style={styles.emptyText}>Nenhum perfil cadastrado</p>
            <p style={styles.emptySub}>Clique em "Novo Perfil" para criar o primeiro perfil do sistema.</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Nome</th>
                  <th style={styles.th}>Descricao</th>
                  <th style={{ ...styles.th, textAlign: 'center' }}>Permissoes</th>
                  <th style={{ ...styles.th, textAlign: 'right' }}>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {perfis.map((perfil, index) => (
                  <tr
                    key={perfil.id}
                    style={{
                      ...styles.trHover,
                      backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f0f7ff'; }}
                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#fafafa'; }}
                  >
                    <td style={styles.td}>
                      <span style={styles.perfilNome}>{perfil.nome}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={styles.perfilDescricao}>{perfil.descricao || '-'}</span>
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      <span style={styles.badge}>
                        {(perfil.permissoes || []).length} {(perfil.permissoes || []).length === 1 ? 'pagina' : 'paginas'}
                      </span>
                    </td>
                    <td style={{ ...styles.td, textAlign: 'right' }}>
                      <div style={{ ...styles.actions, justifyContent: 'flex-end' }}>
                        <button
                          style={styles.btnEditar}
                          onClick={() => handleEditarPerfil(perfil)}
                          onMouseEnter={e => {
                            e.target.style.backgroundColor = '#1976d2';
                            e.target.style.color = '#fff';
                          }}
                          onMouseLeave={e => {
                            e.target.style.backgroundColor = '#fff';
                            e.target.style.color = '#1976d2';
                          }}
                        >
                          Editar
                        </button>
                        <button
                          style={styles.btnDeletar}
                          onClick={() => handleDeletarPerfil(perfil)}
                          onMouseEnter={e => {
                            e.target.style.backgroundColor = '#dc3545';
                            e.target.style.color = '#fff';
                          }}
                          onMouseLeave={e => {
                            e.target.style.backgroundColor = '#fff';
                            e.target.style.color = '#dc3545';
                          }}
                        >
                          Excluir
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal de criacao/edicao */}
      {modalOpen && (
        <div style={styles.overlay} onClick={handleFecharModal}>
          <div style={styles.modal} onClick={e => e.stopPropagation()}>
            {/* Header do modal */}
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>
                {editingPerfil ? 'Editar Perfil' : 'Novo Perfil'}
              </h2>
              <button style={styles.modalClose} onClick={handleFecharModal}>
                ×
              </button>
            </div>

            {/* Body do modal */}
            <div style={styles.modalBody}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Nome do Perfil</label>
                <input
                  type="text"
                  style={styles.input}
                  placeholder="Ex: Administrador, Recepcionista, Laboratorista..."
                  value={formData.nome}
                  onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                  onFocus={e => { e.target.style.borderColor = '#1976d2'; }}
                  onBlur={e => { e.target.style.borderColor = '#ddd'; }}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Descricao</label>
                <textarea
                  style={styles.textarea}
                  placeholder="Descreva as responsabilidades deste perfil..."
                  value={formData.descricao}
                  onChange={e => setFormData(prev => ({ ...prev, descricao: e.target.value }))}
                  onFocus={e => { e.target.style.borderColor = '#1976d2'; }}
                  onBlur={e => { e.target.style.borderColor = '#ddd'; }}
                  rows={2}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>
                  Permissoes de Acesso ({formData.permissoes.length} de {PAGINAS_DISPONIVEIS.length} selecionadas)
                </label>
                <div style={styles.permissoesSection}>
                  {GRUPOS.map(grupo => {
                    const paginasDoGrupo = PAGINAS_DISPONIVEIS.filter(p => p.grupo === grupo);
                    const completo = isGrupoCompleto(grupo);
                    const parcial = isGrupoParcial(grupo);
                    const selecionadasNoGrupo = paginasDoGrupo.filter(p => formData.permissoes.includes(p.rota)).length;

                    return (
                      <div key={grupo} style={styles.grupoWrapper}>
                        {/* Header do grupo com checkbox "selecionar todos" */}
                        <div
                          style={styles.grupoHeader}
                          onClick={() => handleToggleGrupo(grupo)}
                        >
                          <input
                            type="checkbox"
                            checked={completo}
                            ref={el => {
                              if (el) el.indeterminate = parcial;
                            }}
                            onChange={() => handleToggleGrupo(grupo)}
                            style={styles.checkbox}
                            onClick={e => e.stopPropagation()}
                          />
                          <span style={styles.grupoLabel}>{grupo}</span>
                          <span style={styles.grupoCount}>
                            {selecionadasNoGrupo}/{paginasDoGrupo.length}
                          </span>
                        </div>

                        {/* Itens de permissao do grupo */}
                        {paginasDoGrupo.map(pagina => (
                          <div
                            key={pagina.rota}
                            style={{
                              ...styles.permissaoItem,
                              backgroundColor: formData.permissoes.includes(pagina.rota) ? '#f0f7ff' : 'transparent',
                            }}
                            onClick={() => handleTogglePermissao(pagina.rota)}
                            onMouseEnter={e => {
                              if (!formData.permissoes.includes(pagina.rota)) {
                                e.currentTarget.style.backgroundColor = '#f5f5f5';
                              }
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.backgroundColor = formData.permissoes.includes(pagina.rota) ? '#f0f7ff' : 'transparent';
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={formData.permissoes.includes(pagina.rota)}
                              onChange={() => handleTogglePermissao(pagina.rota)}
                              style={styles.checkbox}
                              onClick={e => e.stopPropagation()}
                            />
                            <span style={{ fontSize: '16px' }}>{pagina.icon}</span>
                            <span style={styles.permissaoLabel}>{pagina.label}</span>
                            <span style={{ fontSize: '12px', color: '#aaa', marginLeft: 'auto' }}>{pagina.rota}</span>
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Footer do modal */}
            <div style={styles.modalFooter}>
              <button
                style={styles.btnCancelar}
                onClick={handleFecharModal}
                onMouseEnter={e => { e.target.style.backgroundColor = '#f5f5f5'; }}
                onMouseLeave={e => { e.target.style.backgroundColor = '#fff'; }}
              >
                Cancelar
              </button>
              <button
                style={saving ? styles.btnSalvarDisabled : styles.btnSalvar}
                onClick={handleSalvar}
                disabled={saving}
                onMouseEnter={e => { if (!saving) e.target.style.backgroundColor = '#1565c0'; }}
                onMouseLeave={e => { if (!saving) e.target.style.backgroundColor = '#1976d2'; }}
              >
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GerenciarPerfis;
